const SessionExpiredBanner = () => {
  return (
    <div className="alert ff-inter fs-2">
      <span className="text-uppercase">Your Session is Expired</span>
      <br />
      Please go back to the previous step to select available time of an
      appointment
    </div>
  )
}

export default SessionExpiredBanner
